import { useCallback, useState } from 'react';
import { useRouter } from 'next/navigation';
import { XMarkIcon as CloseIcon } from '@heroicons/react/24/solid';
import Button from 'components/commercetools-ui/atoms/button';
import Modal from 'components/commercetools-ui/atoms/modal';
import Typography from 'components/commercetools-ui/atoms/typography';
import { useFormat } from 'helpers/hooks/useFormat';
import { useCart } from 'frontastic';
import Login from '../../authentication/login';

const LoginSuggestion = () => {
  const { formatMessage: formatCartMessage } = useFormat({ name: 'cart' });
  const { formatMessage: formatAccountMessage } = useFormat({ name: 'account' });
  const router = useRouter();
  const { isEmpty } = useCart();

  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  const openLoginModal = useCallback(() => setIsLoginModalOpen(true), []);
  const closeLoginModal = useCallback(() => setIsLoginModalOpen(false), []);
  const onLogin = useCallback(() => {
    setIsLoginModalOpen(false);
    if (isEmpty) {
      router.push('/account');
    }
  }, [isEmpty]);

  const loginLink = '/login?lvp=cart';

  return (
    <>
      <Typography className="mt-18 border-t border-neutral-400 pt-16 text-14 normal-case leading-[20px] text-secondary-black md:text-14">
        {formatCartMessage({
          id: 'order.summary.login',
          defaultMessage: 'Log in to use your personal offers!',
        })}
      </Typography>
      <Button
        className="mt-8 !h-[44px] w-full pb-30 text-center font-bold"
        onClick={openLoginModal}
        size="l"
        variant="secondary"
      >
        {formatAccountMessage({ id: 'sign.in', defaultMessage: 'Login / Register' })}
      </Button>

      <Modal
        isOpen={isLoginModalOpen}
        onRequestClose={closeLoginModal}
        className="relative w-[90%] rounded-md bg-white"
        style={{ content: { maxWidth: '600px' } }}
        closeTimeoutMS={200}
      >
        <CloseIcon
          className="absolute right-20 top-20 h-24 w-24 cursor-pointer text-secondary-black"
          onClick={closeLoginModal}
        />
        <div className="p-1 pb-48 pt-72">
          <Login onLogin={onLogin} signInLink={{ type: 'link', link: loginLink }} lvp="cart" />
        </div>
      </Modal>
    </>
  );
};

export default LoginSuggestion;
